import angular from "angular";
import notificationStreamModule from "../notificationStreamModule";

function clickInCard(eventStreamService, hybridService, notificationStreamUtility, $log) {
    "ngInject";

    return {
        restrict: "A",
        scope: true,
        link: function (scope, element, attrs) {
            element.bind("click", function (event) {
                if (!event.target) {
                    return false;
                }

                var selectedElm = angular.element(event.target);
                var eventType = selectedElm.attr("type");
                if (event.target && eventType) {
                    var property = angular.copy(scope.library.eventStreamMetaData);
                    if (scope.notification) {
                        property.notificationType = scope.notification.notificationSourceType;
                        scope.interactNotification(scope.notification);
                    }
                    var eventName = eventStreamService.eventNames.notificationStream[eventType];
                    eventStreamService.sendEventWithTarget(eventName,
                        event.type,
                        property);


                    if (scope.library.inApp) {
                        event.stopPropagation();
                        event.preventDefault();
                        switch (eventType) {
                            case notificationStreamUtility.links.settingLinkName:
                                var params = {
                                    feature: notificationStreamUtility.links.settingTabName,
                                    urlPath: notificationStreamUtility.links.settingLink
                                };
                                hybridService.navigateToFeature(params, function (status) {
                                    $log.debug("navigateToFeature ---- status:" + status);
                                });
                                break;
                            case notificationStreamUtility.links.friendRequestLinkName:
                                var params = {
                                    feature: notificationStreamUtility.links.friendRequestTabName,
                                    urlPath: notificationStreamUtility.links.friendRequestLink
                                };
                                hybridService.navigateToFeature(params, function (status) {
                                    $log.debug("openUserProfile ---- status:" + status);
                                });
                                break;
                            case notificationStreamUtility.links.profileLinkName:
                                var userId;
                                if (selectedElm.attr("href") && selectedElm.attr("href").match(/users\/(\d+)/, "")) {
                                    userId = selectedElm.attr("href").match(/users\/(\d+)/, "")[1];
                                } else {
                                    userId = scope.userIds[0];
                                }
                                hybridService.openUserProfile(parseInt(userId), function (status) {
                                    $log.debug("openUserProfile ---- status:" + status);
                                });
                                break;
                        }
                        return false;
                    }
                }

            });
        }
    }
}

notificationStreamModule.directive("clickInCard", clickInCard);

export default clickInCard;